import script from "./DownFileDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./DownFileDialog.vue?vue&type=script&lang=ts&setup=true"

import "./DownFileDialog.vue?vue&type=style&index=0&id=ad824f52&scoped=true&lang=css"

import exportComponent from "/Users/niming/Documents/vue-mooc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad824f52"]])

export default __exports__